import { motion, AnimatePresence } from 'framer-motion';
import { useGameStore } from '../store';
import { useState, useEffect } from 'react';
import { Star } from 'lucide-react';

export function ScoreDisplay() {
  const score = useGameStore((state) => state.score);
  const [displayScore, setDisplayScore] = useState(score);
  const [animationKey, setAnimationKey] = useState(0);

  useEffect(() => {
    if (score !== displayScore) {
      setAnimationKey(prev => prev + 1);
      const steps = 20;
      const stepDuration = 50;
      const increment = (score - displayScore) / steps;
      let currentStep = 0;

      const interval = setInterval(() => {
        currentStep++;
        setDisplayScore(prev => Math.round(prev + increment));
        if (currentStep >= steps) {
          clearInterval(interval);
          setDisplayScore(score);
        }
      }, stepDuration);

      return () => clearInterval(interval);
    }
  }, [score]);

  return (
    <div className="fixed top-0 left-0 right-0 flex justify-center items-center p-3 z-50 font-kawaii">
      <AnimatePresence mode="wait">
        <motion.div
          key={animationKey}
          initial={{ scale: 1.3, opacity: 0, y: -15 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.8, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
          className="bg-white/80 backdrop-blur-xl px-6 py-3 rounded-full shadow-kawaii border-2 border-sakura-200/50 flex items-center gap-2"
        >
          <Star className="w-5 h-5 text-star" />
          <span className="text-2xl font-black bg-gradient-to-r from-sakura-500 to-lavender-500 bg-clip-text text-transparent">
            {displayScore.toLocaleString()}
          </span>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
